import { arrayOf, func, string } from 'prop-types';
import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';

import { getTooltipButtonWithText } from '../../generic/Tooltip';
import { changeApprovalShape } from '../../prop-types';
import { rolesEnum } from '../../users/constants';
import { COLORS } from '../../utils/constants';
import HELP_TEXT from './HELP_TEXT';

class PendingReviews extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  load(handler, approval, reloadOnSuccess = false) {
    this.setState({ loading: true });
    Promise.resolve(handler(approval))
      .then(() => {
        if (reloadOnSuccess) {
          // Adding a setTimeout here to display the final approval
          // response message from the BE
          setTimeout(() => window.location.reload(), 2500);
        }
      })
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    const {
      pendingApprovals,
      approvalRoles,
      currentUserRoles,
      onGrant,
      onDeny,
    } = this.props;
    const { loading } = this.state;
    const hasUserApprovalRole =
      currentUserRoles.includes(rolesEnum.SUPERUSER) ||
      approvalRoles.some(approvalRole =>
        currentUserRoles.includes(approvalRole),
      );
    const shouldReload = pendingApprovals.length === 1;

    const ButtonWithTooltip = getTooltipButtonWithText(
      HELP_TEXT(approvalRoles),
    );
    return pendingApprovals.map(approval => (
      <div className="d-flex align-items-center justify-content-between mb-2">
        {approval.reviewerType}
        <ButtonGroup>
          <ButtonWithTooltip
            section="customMessage"
            helpKey="approval"
            size="sm"
            color={COLORS.SUCCESS}
            onClick={() => this.load(onGrant, approval, shouldReload)}
            disabled={loading || !hasUserApprovalRole}
            showTooltip={!hasUserApprovalRole}
            data-field-name={`grant-${approval.reviewerType}`}
          >
            Grant
          </ButtonWithTooltip>
          <Button
            size="sm"
            color={COLORS.DANGER}
            onClick={() => this.load(onDeny, approval, true)}
            disabled={loading || !hasUserApprovalRole}
            data-field-name={`deny-${approval.reviewerType}`}
          >
            Deny
          </Button>
        </ButtonGroup>
      </div>
    ));
  }
}
PendingReviews.propTypes = {
  pendingApprovals: arrayOf(changeApprovalShape.isRequired).isRequired,
  approvalRoles: arrayOf(string).isRequired,
  currentUserRoles: arrayOf(string).isRequired,
  onGrant: func.isRequired,
  onDeny: func.isRequired,
};

export default PendingReviews;
